import ClaimHandlingTable from './ClaimHandlingTable'

export default ClaimHandlingTable
